/**
 * URLs serveur — même logique que common.js
 * Modifier LOCAL_DEV_DOMAIN dans common.js (source de vérité)
 */
export const LOCAL_DEV_DOMAIN = 'dev.optimahr.dev'

export function isLocalhost() {
    return (
        document.location.hostname === 'localhost' ||
        document.location.hostname.endsWith('localhost') ||
        document.location.hostname.includes('kiwhacks')
    )
}

export function getServerDomain() {
    return isLocalhost() ? LOCAL_DEV_DOMAIN : document.location.hostname
}

export function getAuthBaseUrl() {
    return `https://auth.${getServerDomain()}`
}

export function getUserBaseUrl() {
    return `https://user.${getServerDomain()}`
}

/**
 * Portail de support de l'hote courant. Les domaines optimahr.dev n'ont pas de ticketing a eux ;
 * « sandbox », « test » et « www » ne sont pas des environnements de ticketing ; une préproduction
 * (<client>preprod) partage celui de son client.
 */
export function getSupportBaseUrl(host = getServerDomain()) {
  if (host === 'optimahr.dev' || host.endsWith('.optimahr.dev')) return 'https://support.optimahr.app'
  const brandHost = host.replace(/^(sandbox|test)\./, '').replace(/^www\./, '').replace(/^([a-z0-9]+)preprod\./, '$1.')
  return `https://support.${brandHost}`
}
